<div class="eu-dialog">
  <div class="eu-header">
    <div class="eu-title-wrap">
      <div class="eu-title-icon"><mat-icon>edit_calendar</mat-icon></div>
      <div>
        <h2 class="eu-title">Edit event</h2>
        <div class="eu-subtitle">{{event.startDateTime.seconds * 1000 | date:'EEEE, MMMM d, y'}}</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="eu-close" [disabled]="saving || deleting" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form id="updateEvent" class="eu-form" (ngSubmit)="saveEvent()">
    <div class="eu-hero">
      <div class="eu-hero-input">
        <input class="eu-desc" [class.invalid]="descriptionHasError" type="text" name="description"
          placeholder="What needs to be done?" [disabled]="!editEventAbility" [(ngModel)]="event.description">
        @if (descriptionHasError) {
          <div class="eu-error">Event description cannot be empty</div>
        }
      </div>
      @if (editEventAbility) {
        <button type="button" class="eu-flag" [class.on]="event.highPriority"
          [disabled]="!completeEvent" (click)="event.highPriority = !event.highPriority">
          <mat-icon>flag</mat-icon>High priority
        </button>
      }
    </div>

    <div class="eu-scroll">
      <div class="eu-body">
        <section class="eu-main">
          @if (detailTableItems.length > 0) {
            <div class="eu-context">
              @for (item of detailTableItems; track item) {
                <div class="eu-context-row">
                  <span>{{item.label}}</span>
                  <a [routerLink]="item.link ? [item.link] : null" [class.clickable]="item.link != null">
                    <i [style.background]="item.color"></i>{{item.value}}
                  </a>
                </div>
              }
            </div>
          }

          <div class="eu-section">
            <div class="eu-section-head">
              <span class="eu-section-title"><mat-icon>event</mat-icon>Schedule</span>
            </div>

            @if (!assignToGroup) {
              <div class="eu-field">
                <label class="eu-label">Phase</label>
                <div class="eu-picker">
                  <app-phase-select [disabled]="!completeEvent" [harvestId]="harvestId" [(phase)]="event.phase"></app-phase-select>
                </div>
              </div>
            }

            <div class="eu-schedule-grid">
              <div class="eu-field">
                <label class="eu-label">Date</label>
                <mat-form-field appearance="outline" class="eu-mat">
                  <input matInput [matDatepicker]="startDatePicker" [formControl]="startDate" disabled="true">
                  <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker [disabled]="!completeEvent"></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="eu-field">
                <label class="eu-label">Time</label>
                <div class="eu-time-row">
                  <div class="eu-seg">
                    <button type="button" [class.on]="event.anyTime" [disabled]="!completeEvent || !editEventAbility" (click)="event.anyTime = true">Anytime</button>
                    <button type="button" [class.on]="!event.anyTime" [disabled]="!completeEvent || !editEventAbility" (click)="event.anyTime = false">At a time</button>
                  </div>
                  @if (!event.anyTime && editEventAbility) {
                    <input class="eu-time" name="startTime" type="time" [disabled]="!completeEvent" [(ngModel)]="eventTime">
                  }
                </div>
              </div>
            </div>

            @if (event.slidingEnd != null) {
              <div class="eu-field eu-field-last">
                <label class="eu-label">Sliding deadline</label>
                <mat-form-field appearance="outline" class="eu-mat">
                  <input matInput name="slidingEndDate" [matDatepicker]="slidingEndDatePicker" [formControl]="slidingEndDate" disabled="true">
                  <mat-datepicker-toggle matSuffix [for]="slidingEndDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #slidingEndDatePicker [disabled]="!editEventAbility"></mat-datepicker>
                  <mat-hint>Automatically moves until completed; due {{slidingEndDate.value | date:'MM/dd/yyyy'}}.</mat-hint>
                </mat-form-field>
              </div>
            }
          </div>

          <div class="eu-section">
            <div class="eu-section-head">
              <span class="eu-section-title"><mat-icon>forum</mat-icon>Notes</span>
            </div>
            <app-messaging
              [disabled]="!editEventAbility"
              [discussions]="event.discussions"
              [(notes)]="notes"
              (deleteMessage)="deleteMessage($event)"
              [assignToGroup]="assignToGroup"
              [parentId]="parentId"
              [eventId]="event.id"
              [(sending)]="sendingNote">
            </app-messaging>
          </div>
        </section>

        <aside class="eu-side">
          <div class="eu-side-section">
            <div class="eu-side-head">
              <span class="eu-side-title">Assignees</span>
              @if (assignUserAbility) {
                <button type="button" class="eu-mini-btn" (click)="selectTeamsUsers()">
                  <mat-icon>person_add</mat-icon>{{assignedTeamsUsers ? 'Edit' : 'Assign'}}
                </button>
              }
            </div>
            @if (assignedTeamsUsers) {
              <div class="eu-summary"><mat-icon>group</mat-icon>{{assignedTeamsUsers}} team/user selection{{assignedTeamsUsers === 1 ? '' : 's'}}</div>
            } @else {
              <div class="eu-side-empty">No one assigned yet</div>
            }
          </div>

          <div class="eu-side-section eu-status">
            <div class="eu-side-head"><span class="eu-side-title">Status</span></div>
            <div class="eu-complete-row tooltip-wrapper">
              <mat-checkbox name="completed" [disabled]="!completeEvent || mustCompleteSubtasks"
                [(ngModel)]="event.completed" (click)="showTooltip($event)">Completed</mat-checkbox>
              <span #tooltip="matTooltip" matTooltip="Must complete all subtasks before completing event"
                matTooltipShowDelay="0" matTooltipHideDelay="3000"></span>
            </div>
          </div>

          <div class="eu-side-section">
            <app-chip-list-edit [disabled]="!completeEvent" [label]="'Tags'" [allChips]="allTags" [(chips)]="event.tags"></app-chip-list-edit>
          </div>

          <div class="eu-side-section">
            <div class="eu-side-head">
              <span class="eu-side-title">Time tracking</span>
              @if (event.estimatedTime != null) { <span class="eu-estimate">Est. {{event.estimatedTime}} min</span> }
            </div>
            <mat-form-field appearance="outline" class="eu-mat" [class.mat-form-field-invalid]="timeSpentHasError">
              <input matInput placeholder="Minutes spent" name="timeSpent" [disabled]="!completeEvent" [(ngModel)]="event.timeSpent" type="number">
              <button type="button" mat-icon-button matSuffix [disabled]="!completeEvent" (click)="stopwatchClick()" aria-label="Open stopwatch">
                <mat-icon>timer</mat-icon>
              </button>
              @if (timeSpentHasError) { <mat-hint class="mat-error">Event must have time spent</mat-hint> }
            </mat-form-field>
          </div>

          @if (qualityTrackerAbility) {
            <div class="eu-side-section">
              <div class="eu-side-head"><span class="eu-side-title">Quality tracker</span><span class="eu-quality">{{event.efficacy || 0}}%</span></div>
              <mat-slider class="eu-slider" discrete [disabled]="!completeEvent" [displayWith]="formatLabel" min="0" max="100">
                <input matSliderThumb [(ngModel)]="event.efficacy" name="efficacy" aria-label="Quality percentage">
              </mat-slider>
            </div>

            <div class="eu-side-section">
              <div class="eu-side-head">
                <span class="eu-side-title">Subtasks</span>
                @if (editEventAbility) {
                  <button type="button" class="eu-mini-btn" (click)="editSubtasks($event)" [disabled]="event.completed">
                    <mat-icon>checklist</mat-icon>Edit
                  </button>
                }
              </div>
              @if (!subtasksEmpty) {
                <ul class="eu-subtasks">
                  @for (subtask of subtasks; track subtask) {
                    <li>
                      <div class="eu-subtask-row">
                        <mat-checkbox class="subtask_checks" [(ngModel)]="subtask.subtask.completed" [ngModelOptions]="{standalone: true}">{{subtask.subtask.title}}</mat-checkbox>
                        @if (subtask.subtask.description?.length > 0) {
                          <button type="button" class="eu-expand" (click)="subtaskDescToggle($event, subtask)" aria-label="Toggle subtask description">
                            <mat-icon>{{subtask.displayDescription ? 'expand_less' : 'expand_more'}}</mat-icon>
                          </button>
                        }
                      </div>
                      @if (subtask.displayDescription) { <p>{{subtask.subtask.description}}</p> }
                    </li>
                  }
                </ul>
              } @else {
                <div class="eu-side-empty">No subtasks yet</div>
              }
            </div>

            <div class="eu-side-section">
              <div class="eu-side-head">
                <span class="eu-side-title">Data collection</span>
                @if (event.dataCollectionDefinitions?.length > 0) {
                  <button type="button" class="eu-mini-btn" (click)="submitData($event)" [disabled]="event.completed">
                    <mat-icon>query_stats</mat-icon>Enter data
                  </button>
                }
              </div>
              @if (event.dataCollectionDefinitions?.length > 0) {
                <div class="eu-summary"><mat-icon>analytics</mat-icon>{{event.dataCollectionDefinitions.length}} field{{event.dataCollectionDefinitions.length === 1 ? '' : 's'}} · {{event.dataSubmissions?.length || 0}} submission{{event.dataSubmissions?.length === 1 ? '' : 's'}}</div>
              } @else {
                <div class="eu-side-empty">No data collection configured</div>
              }
            </div>
          }
        </aside>
      </div>

      <section class="eu-discussion">
        <div class="eu-section-head"><span class="eu-section-title"><mat-icon>history</mat-icon>Activity</span></div>
        <app-discussion-panel [discussions]="event.discussions"></app-discussion-panel>
      </section>
    </div>
  </form>

  <div class="eu-attachments">
    @if (completeEvent) {
      <button type="button" class="eu-attach-btn" [matMenuTriggerFor]="menu"><mat-icon>attach_file</mat-icon>Add attachment</button>
    }
    <mat-menu #menu="matMenu">
      <input #file type="file" id="selectedFile" hidden (change)="fileChange(file.files)" />
      <button type="button" mat-menu-item (click)="browseForFile()"><mat-icon>computer</mat-icon>From computer</button>
      <button type="button" mat-menu-item (click)="cloudStorageClick()"><mat-icon>cloud</mat-icon>Cloud storage URL</button>
    </mat-menu>
    <div class="eu-attachment-list">
      @for (attachment of event.cloudAttachments || []; track attachment) {
        <a class="eu-cloud" [href]="attachment" target="_blank" rel="noopener" title="Open cloud attachment"
          (contextmenu)="openCloudAttachmentMenu($event, attachment, cloudMenuTrigger)"><i [ngClass]="getClass(attachment)"></i></a>
      }
      @for (attachment of event.attachments || []; track attachment) { <app-attachment-btn [id]="attachment"></app-attachment-btn> }
      @if (fileToUpload != null) { <span class="eu-file-pending"><mat-icon>upload</mat-icon>{{fileToUpload.name}} uploads on save</span> }
    </div>
    <div class="eu-menu-anchor" [style.left.px]="cloudMenuPosition.x" [style.top.px]="cloudMenuPosition.y"
      [matMenuTriggerFor]="cloudMenu" #cloudMenuTrigger="matMenuTrigger"></div>
    <mat-menu #cloudMenu="matMenu"><button mat-menu-item (click)="removeCloudAttachment(cloudMenuSubject)">Remove</button></mat-menu>
  </div>

  <div class="eu-footer">
    <div>
      @if (deleteEventAbility) {
        <button type="button" class="eu-delete" [disabled]="saving || deleting" (click)="deleteClick()">
          @if (deleting) { <mat-spinner diameter="18" strokeWidth="3"></mat-spinner> } @else { <mat-icon>delete_outline</mat-icon><span>Delete</span> }
        </button>
      }
    </div>
    <div class="eu-footer-actions">
      @if (completeEvent) {
        <button mat-button mat-dialog-close id="eventUpdate-Cancel" class="eu-btn-ghost" [disabled]="saving || deleting">Cancel</button>
        <button type="submit" form="updateEvent" class="eu-btn-primary" [disabled]="saving || deleting || sendingNote">
          @if (saving) { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> } @else { <span>Save changes</span><mat-icon>check</mat-icon> }
        </button>
      }
    </div>
  </div>
</div>
